import { useContext } from 'react'
import { useParams } from 'react-router-dom'

import { helpers, Loading } from '@reveni-io/reveni-ui'

import PromotionalBanner from '../components/PromotionalBanner'
import AppContext from '../context/AppContext'
import useLabelTrackingInfo from './hooks/useLabelTrackingInfo/useLabelTrackingInfo'
import OrderInfoCard from './OrderInfoCard/OrderInfoCard'
import ProductsCard from './ProductsCard/ProductsCard'
import * as Styles from './styles'

const LabelTrackingPage = () => {
  const { id } = useParams()
  const { trackingInfo, fetchingTrackingInfo } = useLabelTrackingInfo({ trackingId: id })
  const { context } = useContext(AppContext)

  return (
    <Loading show={fetchingTrackingInfo}>
      <Styles.Container>
        <OrderInfoCard info={trackingInfo} />
        <ProductsCard
          products={helpers.joinLineItemsAndLineItemGroups(
            helpers.flattenLineItems(trackingInfo?.line_items),
            trackingInfo?.line_item_groups
          )}
        />
        <PromotionalBanner
          imageUrl={
            context?.merchantInfo?.theme?.tracking_footer_image_url ||
            trackingInfo?.portal?.theme?.tracking_footer_image_url
          }
          url={context?.merchantInfo?.theme?.tracking_footer_url || trackingInfo?.portal?.theme?.tracking_footer_url}
        />
      </Styles.Container>
    </Loading>
  )
}

export default LabelTrackingPage
